import type {MaterialOrder} from '@domain/material-storage/src/types'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const MaterialOrdersQueryKey = 'materialOrders'

type Params<TSelect = MaterialOrder[]> = {
  plantCode: string
  materialId: number
  from?: string
  to?: string
  options?: Omit<UseQueryOptions<MaterialOrder[], AxiosError, TSelect>, 'queryKey' | 'queryFn'>
}

export const useMaterialOrdersQuery = <TSelect = MaterialOrder[]>({
  plantCode,
  materialId,
  from,
  to,
  options
}: Params<TSelect>) =>
  useQuery<MaterialOrder[], AxiosError, TSelect>({
    queryKey: [MaterialOrdersQueryKey, plantCode, materialId, from, to],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<MaterialOrder[]>(
        `/plants/${plantCode}/material-orders`,
        {params: {from, to, materialId}, signal}
      )
      return response.data
    },
    ...options
  })
